import React from 'react';
const CheckboxGroupContext = React.createContext(null);
export default CheckboxGroupContext;
